import { gql } from "@apollo/client";
import {
  CategoryNoNestingFragment,
  MarkupNoNestingFragment,
  PaginatedListMetaNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { Category as CategoryEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import CategoryModel from "../../data/model/Category";
import { listOptions, listVariables } from "../constants";
import { EntityResourceDefinition } from "../entity-resource-definition";
import { pageQuery } from "../page-query";

const categoriesQuery = gql`
${CategoryNoNestingFragment}
${PaginatedListMetaNoNestingFragment}
${MarkupNoNestingFragment}
query GetCategories(${listVariables}) {
    categories(${listOptions}) {
        items {
          ...CategoryNoNesting
          markup {
            ...MarkupNoNesting
          }
        }
        meta {
          ...PaginatedListMetaNoNesting
        }
    }
}
`;

export const categoryDefinition = new EntityResourceDefinition<
  CategoryEntity,
  CategoryModel
>({
  entity: "categories",
  query: categoriesQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.name = fetchedEntity?.name || "";
    newEntity.description = fetchedEntity.description || null;
    newEntity.department.id = fetchedEntity.departmentId;
    newEntity.markup = fetchedEntity.markup || [];
    newEntity.preferredTaxGroupId = fetchedEntity.preferredTaxGroupId || null;
  },
  fetchEntities: (options) => {
    return pageQuery(client, "categories", categoriesQuery, options);
  },
});
